import { get } from "lodash";
import {
    GetAllTarrifs,
    getFullchannels,
    getUserInfo,
    getChannelList,
    getQrPayme,
    customerSubscribe,
} from "../Api";

import Payment from "../widgets/payment/api/Payment";
export default {
    state: {
        isPaymentModalActive: false,
        isPaymentModalTvChannelsActive: false,
        chanelsNeedList: [],
        chaanelsListCaption: null,
        openedTarrifId: null,
        allTarrifs: null,
        currentTarrif: null,
        cuerruntSubs: null,
        userInfo: null,
        cards: null,
        cardLoading: false,
        card_bind_transaction_id: null,
        cardError: {
            value: false,
            msg: "",
            forw: "",
        },
        topUpBalanceViaCardError: {
            value: false,
            msg: "",
            forw: "",
        },
        orderError: {
            value: false,
            msg: "",
            forw: "",
        },
        paymePaymnetLink: null,
        cardVerifyLoading: false,
        currentCardToPay: null,
        succesPaymnetTransaction: false,
        goToSuccesStep: false,
        isCardHaveMoney: true,
        userInfoLoading: false,
        isPaymentModalActiveType: "",
        modalTypes: {
            cabinet: "cabinet",
            tv: "tv",
            movie: "movie",
        },
        availableSubscriptions: null,
        excludedSubscriptionTariffId: 100,
        excludedSubscriptionTariffIds: [100, 101, 102, 103],
        alreadyActivateOneSum: false,
    },

    mutations: {
        setIsPaymentModalActive(state, content) {
            state.isPaymentModalActive = content;
            if (!content) {
                state.isPaymentModalTvChannelsActive = false;
                state.openedTarrifId = null;
                state.succesPaymnetTransaction = false;
            }
            this.currentCardToPay = null;
            // document.body.style.overflow = content ? "hidden" : "auto";
            document.body.className = content ? "hidden" : "auto";
        },
        setIsPaymentModalActiveType(state, content) {
            state.isPaymentModalActiveType = content;
        },
        setAvailableSubscriptions(state, content) {
            state.availableSubscriptions = content;
        },
        setIsPaymentModalTvChannelsActive(state, content) {
            const { value, id, mainClose = false } = content;
            if (mainClose) {
                state.isPaymentModalTvChannelsActive = false;
                state.openedTarrifId = null;
                return;
            }
            if (state.openedTarrifId === id) {
                state.isPaymentModalTvChannelsActive =
                    !state.isPaymentModalTvChannelsActive;
                state.openedTarrifId = null;
            } else {
                state.isPaymentModalTvChannelsActive = value;
                state.openedTarrifId = id;
            }
        },
        SET_ALL_TARRIFS(state, content) {
            state.allTarrifs = content;
        },
        setCardErrors(state, content) {
            const { value, msg, forw } = content;
            state.cardError.value = value;
            state.cardError.msg = msg;
            state.cardError.for = forw;
        },
        setSuccesPaymnetTransaction(state, content) {
            state.succesPaymnetTransaction = content;
        },
        setRopUpBalanceViaCardError(state, content) {
            const { value, msg, forw } = content;
            state.topUpBalanceViaCardError.value = value;
            state.topUpBalanceViaCardError.msg = msg;
            state.topUpBalanceViaCardError.for = forw;
        },
        setOrderError(state, content) {
            const { value, msg, forw } = content;
            state.orderError.value = value;
            state.orderError.msg = msg;
            state.orderError.for = forw;
        },
        SET_CHANNELS_NEED_LIST(state, content) {
            const { response, id } = content;
            if (!state.chanelsNeedList[id]) {
                state.chanelsNeedList[id] = response;
            }
        },
        setCaption(state, content) {
            state.chaanelsListCaption = content;
        },
        setCurrentTarrif(state, content) {
            state.currentTarrif = content;
            if (
                state.currentTarrif?.sub_tariffs &&
                state.currentTarrif?.sub_tariffs.length === 0
            ) {
                state.currentTarrif.sub_tariffs = [
                    {
                        id: state.currentTarrif.id,
                        is_recommended: false,
                        name_en: "1 месяц",
                        name_ru: "1 месяц",
                        name_uz: "1 месяц",
                        period_en: "30 дней",
                        period_ru: "30 дней",
                        period_uz: "30 дней",
                        price: state.currentTarrif.price,
                        provider_id: state.currentTarrif.provider_id,
                        remote_tariff_id: state.currentTarrif.tariff_id,
                    },
                ];
            }
        },
        setCurrentSubs(state, content) {
            state.cuerruntSubs = content;
        },
        SET_USER_INFO(state, content) {
            state.userInfo = content;
            const subs = state.userInfo?.subscriptions;
            const premium_max_for_one_sum =
                state.userInfo?.promotions.premium_max_for_one_sum;
            state.alreadyActivateOneSum =
                premium_max_for_one_sum === 0 ? false : true;
            // if (subs) {
            //     const currentSub = subs.find(
            //         (sub) =>
            //             sub.tariff_id === state.excludedSubscriptionTariffId
            //     );
            //     const subItem = subs.find((sub) =>
            //         state.excludedSubscriptionTariffIds.includes(sub.tariff_id)
            //     );

            //     const isTariffExpired = subItem
            //         ? new Date(subItem?.end_date) < new Date()
            //         : true;

            //     if (currentSub || !isTariffExpired) {
            //         state.alreadyActivateOneSum = false;
            //     } else {
            //         state.alreadyActivateOneSum = true;
            //     }
            // }
        },
        SET_ALLREADY_ACTIVATE_ONE_SUM(state, content) {
            state.alreadyActivateOneSum = content;
        },
        SET_USER_INFO_LOADING(state, content) {
            state.userInfoLoading = content;
        },
        setIsCardHaveMoney(state, content) {
            state.isCardHaveMoney = content;
        },
        SET_USER_CARDS(state, content) {
            state.cards = content;
        },
        SET_CARD_LOADING(state, content) {
            state.cardLoading = content;
        },
        SET_BALANCE(state, content) {
            state.currentOrder = content;
        },
        SET_VERIFY_CARD(state, content) {
            state.card_bind_transaction_id = content?.card_bind_transaction_id;
        },
        SET_CARDVerify_LOADING(state, content) {
            state.cardVerifyLoading = content;
        },
        setCurrentCardToPay(state, content) {
            state.currentCardToPay = content;
        },
        SET_PAYMNET_PAYME(state, content) {
            state.paymePaymnetLink = content.result?.cheque._id;
        },
        setToSuccesStep(state, content) {
            state.goToSuccesStep = content;
        },
    },

    actions: {
        async getAllTarrifs({ commit }) {
            const response = await GetAllTarrifs();
            commit("SET_ALL_TARRIFS", response);
        },
        async getNeedChanels({ commit, state }, payload) {
            const response = await getFullchannels(payload);
            commit("SET_CHANNELS_NEED_LIST", {
                response: response,
                id: payload,
            });
        },
        async getUserInfoForPayment({ commit }) {
            commit("SET_USER_INFO_LOADING", true);
            const response = await getUserInfo();
            commit("SET_USER_INFO", response);
            commit("SET_USER_INFO_LOADING", false);
        },
        async getCardsForPayment({ commit }) {
            commit("SET_CARD_LOADING", true);
            const response = await Payment.getSavedCards();
            commit("SET_CARD_LOADING", false);
            commit("SET_USER_CARDS", response.data);
        },

        async topUpBalance({ commit }, payload) {
            const { tariff_id } = payload;
            const response = await Payment.activateTariffByNewCard(tariff_id);
            if (response.code === 0) {
                commit("SET_BALANCE", response.data);
            } else {
                commit("setOrderError", {
                    value: true,
                    msg: response.message,
                    forw: "",
                });
            }
        },
        async paymePaymnetLink({ commit, state }, payload) {
            const { abonement, money } = payload;
            const price = Number(money);
            const balance = Number(state.userInfo.balance);
            let amount;

            if (price < balance) {
                amount = price;
            } else {
                const difference = price - balance;
                amount = difference > 1000 ? difference : 1000;
            }
            const { data } = await getQrPayme(abonement, amount * 100);
            commit("SET_PAYMNET_PAYME", data);
        },
        async topUpBalanceViaCard({ commit }, payload) {
            commit("SET_CARDVerify_LOADING", true);
            const response = await Payment.activateTariffBySavedCard(payload);
            if (response.code === 0) {
                commit("SET_CARDVerify_LOADING", false);
                commit("setSuccesPaymnetTransaction", true);
                commit("setRopUpBalanceViaCardError", {
                    value: false,
                    msg: "",
                    forw: "",
                });
            } else {
                commit("setRopUpBalanceViaCardError", {
                    value: true,
                    msg: response.message,
                    forw: "",
                });
                commit("SET_CARDVerify_LOADING", false);
            }
        },
        async payFromBalance({ commit }, payload) {
            commit("SET_CARDVerify_LOADING", true);
            const response = await customerSubscribe(payload);
            if (response.error === 0) {
                commit("SET_CARDVerify_LOADING", false);
                commit("setRopUpBalanceViaCardError", {
                    value: false,
                    msg: "",
                    forw: "",
                });
                commit("setToSuccesStep", true);
            } else {
                commit("setRopUpBalanceViaCardError", {
                    value: true,
                    msg: "Что то пошло не так",
                    forw: "",
                });
                commit("SET_CARDVerify_LOADING", false);
            }
        },

        async initCardsVerify({ commit }, payload) {
            commit("SET_CARDVerify_LOADING", true);
            const response = await Payment.initTransaction(payload);
            if (response.code === 0) {
                commit("SET_CARDVerify_LOADING", false);
                commit("SET_VERIFY_CARD", response.data);
                if (response.data.card_bind_transaction_id === null) {
                    commit("setCardErrors", {
                        value: true,
                        msg: "Что то пошло не так. Попробуйте еще раз",
                        forw: "",
                    });
                }
            } else {
                commit("setCardErrors", {
                    value: true,
                    msg: response.message,
                    forw: "",
                });
                commit("SET_CARDVerify_LOADING", false);
            }
        },

        async confirmTransaction({ commit }, payload) {
            commit("SET_CARDVerify_LOADING", true);
            const response = await Payment.confirmTransaction(payload);
            if (response.code === 0) {
                commit("SET_CARDVerify_LOADING", false);
                commit("setSuccesPaymnetTransaction", true);
            } else {
                if (response.code === 6000) {
                    commit("setCardErrors", {
                        value: true,
                        msg: response.message,
                        forw: "notMoney",
                    });
                } else {
                    commit("setCardErrors", {
                        value: true,
                        msg: response.message,
                        forw: "",
                    });
                }
                commit("SET_CARDVerify_LOADING", false);
            }
            const res = await Payment.getSavedCards();
            commit("SET_USER_CARDS", res.data);
        },
    },

    getters: {
        getPaymentModalActive(state) {
            return state.isPaymentModalActive;
        },

        getMyAllTarrifs(state) {
            return state.allTarrifs;
        },

        getIsPaymentModalTvChannelsActive(state) {
            return state.isPaymentModalTvChannelsActive;
        },

        getChanelsNeedList(state) {
            return state.chanelsNeedList;
        },
        getOpenedTarrifId(state) {
            return state.openedTarrifId;
        },
        getChannelsCaption(state) {
            return state.chaanelsListCaption;
        },
        getCurrentTarrif(state) {
            return state.currentTarrif;
        },
        getCurrentSubs(state) {
            return state.cuerruntSubs;
        },

        getUserInfoForPayment(state) {
            return state.userInfo;
        },
        getUserInfoLoading(state) {
            return state.userInfoLoading;
        },

        getCardsForPayment(state) {
            return state.cards;
        },
        isCardLoading(state) {
            return state.cardLoading;
        },
        getCurrentOrder(state) {
            return state.currentOrder;
        },
        getCardErrors(state) {
            return state.cardError;
        },
        getCardVerifyLoading(state) {
            return state.cardVerifyLoading;
        },

        getCardBindTransactionId(state) {
            return state.card_bind_transaction_id;
        },
        getCurrentCardToPay(state) {
            return state.currentCardToPay;
        },
        getTopUpBalanceViaCardError(state) {
            return state.topUpBalanceViaCardError;
        },
        getSuccesPaymnetTransaction(state) {
            return state.succesPaymnetTransaction;
        },
        getPaymePaymnetLink(state) {
            return state.paymePaymnetLink;
        },
        getSetToSuccesStep(state) {
            return state.goToSuccesStep;
        },
        getIsCardHaveMoney(state) {
            return state.isCardHaveMoney;
        },
        getOrdereRROR(state) {
            return state.orderError.value;
        },
        getIsPaymentModalActiveType(state) {
            return state.isPaymentModalActiveType;
        },
        getModalTypes(state) {
            return state.modalTypes;
        },
        getAvailableSubscriptions(state) {
            return state.availableSubscriptions;
        },
        getAlreadyActivateOneSum(state) {
            return state.alreadyActivateOneSum;
        },
    },
};
